import "./header";
import "./consultation-video";
import "./faq";
import "./contact";
import "./blog-archive";
import "./tabs";
import "./privacy-loader";


import scrollTop from './scrollTop';

document.addEventListener('DOMContentLoaded', () => {
  scrollTop();
});